$ = require 'jquery'
PopOver = require 'app/scripts/views/lib/pop-over'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
_ = require 'underscore'
template = require 'app/scripts/views/templates/popover_add_list'
{ track } = require '@trello/analytics'
{ Analytics } = require '@trello/atlassian-analytics'
{ featureFlagClient } = require '@trello/feature-flag-client'

module.exports = class AddListPopoverView extends View
  viewTitleKey: 'add list'

  events:
    'change .js-select-list-pos': 'renderValue'
    'click .js-add-list': 'addList'
    'submit form': 'addList'

  initialize: ({ @didAddList }) ->
    super

  getLists: ->
    @lists = @model.listList
    @listsLength = @lists.length + 1

  render: ->
    view = @

    @$el.html(
      template({
        tooManyTotalLists: @model.isOverLimit('lists', 'totalPerBoard')
        tooManyOpenLists: @model.isOverLimit('lists', 'openPerBoard')
      })
    )

    # We need to use setTimeout so that PopOver.calcPos() will finish and we
    # can reliably get this element's left offset in @getClosestListPos().
    @setTimeout =>
      @getClosestListPos()
      @getLists()
      @updateListList()
    , 10

    @

  getClosestListPos: ->
    # find closest list
    elLists = $('.js-list')
    listxdiffs = []
    @closestListIdx = 0

    elLists.each (i) =>
      diff = parseInt(Math.abs($(elLists[i]).offset().left + ($(elLists[i]).width() / 2) - @$el.offset().left), 10)
      listxdiffs.push(diff)

    @closestListIdx = _.indexOf(listxdiffs, _.min(listxdiffs))

    $closestList = $(elLists[@closestListIdx])
    if ($closestList.length > 0 &&
        (@$el.offset().left >
          ($closestList.offset().left + ($closestList.width() / 2))) &&
        @closestListIdx < elLists.length)
      @closestListIdx += 1

  updateListList: ->
    view = @

    $el = $(view.el)
    $selectList = $el.find('.js-select-list-pos')

    $('<option>').val(i).text(i + 1).appendTo($selectList) for i in [0...@listsLength]

    $option = $selectList.find('option:last')

    $option = $selectList.find("option:eq(#{@closestListIdx})")

    $option.attr('selected', 'selected')

    @renderValue()


  renderValue: ->
    num = parseInt(@$('.js-select-list-pos').val(), 10) + 1
    $('.js-pos-value').text(num.toString())
    return


  addList: (e) ->
    Util.stop(e)
    listName = @$('.js-list-name').val().trim()
    if listName == ''
      @$('.js-list-name').focus().select()
      return

    $selectListPos = @$('.js-select-list-pos')

    listPosSelected = parseInt($selectListPos.find('option:selected').val(), 10)

    if listPosSelected == (@listsLength - 1)
      changedPos = false
    else
      changedPos = true

    if listName == "List" # default name
      changedName = false
    else
      changedName = true

    PopOver.hide()

    createdList = @model.listList.create(
      {
        name: listName
        pos: @model.calcPos(listPosSelected)
        closed: false
      },
      {
        success: (model) =>
          if changedName and changedPos
            track("Board", "Add List", "Successfully Add List - Changed Name, Changed Position")
          else if changedName
            track("Board", "Add List", "Successfully Add List - Changed Name, Default Position")
          else if changedPos
            track("Board", "Add List", "Successfully Add List - Default Name, Changed Position")
          else
            track("Board", "Add List", "Successfully Add List - Default Name, Default Position")

          # We're no longer tracking changedName
          if featureFlagClient.get('dataeng.gasv3-core-event-tracking', false)
            Analytics.sendTrackEvent
              action: 'created'
              actionSubject: 'list'
              source: 'addListInlineDialog'
              containers:
                board:
                  id: @model.id
                list:
                  id: model.id
              attributes:
                changedPosition: changedPos

          @didAddList model
        error: =>
          @model.listList.remove(createdList)
      }
    )
    return
